import cn from 'classnames'
import { FC, useCallback } from 'react'

import { FormInput, useGetFormDataField } from 'cng-common/features/form'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { TRANSLATION_KEYS } from '../../translations'

import styles from './TickerEditMode.module.scss'

interface ITickerEditModeProps {
  ticker: string
}

const tooltipMessage = 'This value is required for completeness'
export const TickerEditMode: FC<ITickerEditModeProps> = ({ ticker }) => {
  const [formTicker] = useGetFormDataField<string>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.ticker
  )

  const shouldShowCompletenessWarning = useCallback((currentValue: string) => {
    return currentValue === null
  }, [])

  const tooltipRender = useCallback(() => {
    return <>{tooltipMessage}</>
  }, [])

  const formTickerTooltipCondition = shouldShowCompletenessWarning(formTicker) && !formTicker

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <Tooltip disabled={!formTickerTooltipCondition} tipContent={tooltipRender}>
            <FormInput
              formKey={PARTNER_BASIC_INFO_FORM_KEY}
              field={partnerBasicInfoFields.ticker}
              label={TRANSLATION_KEYS.tickerLabel}
              defaultValue={ticker}
              className={cn({
                [styles.warning]: formTickerTooltipCondition,
              })}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
